import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GroupService {
  API_SERVER: string = environment.baseApiUrl;
  reloadTable$ = new BehaviorSubject(false);

  constructor(private httpClient: HttpClient) {}

  findAll(params?): Observable<any> {
    let Params = new HttpParams();
    if (params && Object.keys(params).length > 0) {
      params.forEach((elem) => {
        Params = Params.append(elem.key, elem.val);
      });
    }
    return this.httpClient
      .get(this.API_SERVER + 'group', { params: Params });
  }

  findGroups(id): Observable<any> {
    return this.httpClient
      .get(this.API_SERVER + `group/user/${id}`);
  }
  
  findOwn(): Observable<any> {
    return this.httpClient
      .get(this.API_SERVER + `group/own`);
  }

  updateGroups(id, groups: string[]): Observable<any> {
    return this.httpClient
      .put(this.API_SERVER + `group/user/${id}`, groups);
  }

  findOne(id): Observable<any> {
    return this.httpClient
      .get(this.API_SERVER + `group/${id}`);
  }

  create(data): Observable<any> {
    return this.httpClient
      .post(this.API_SERVER + 'group', data);
  }

  update(id, data): Observable<any> {
    return this.httpClient
      .put(this.API_SERVER + `group/${id}`, data);
  }

  remove(id): Observable<any> {
    return this.httpClient
      .delete(this.API_SERVER + `group/${id}`);
  }

  restore(id): Observable<any> {
    return this.httpClient
      .delete(this.API_SERVER + `group/restore/${id}`);
  }
}
